import { forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface InputNumericProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  label?: string;
  error?: string;
}

export const InputNumeric = forwardRef<HTMLInputElement, InputNumericProps>(
  ({ label, error, required = false, className, id, ...props }, ref) => {
    const inputClasses = twMerge("input input-bordered w-full", error && "input-error");

    return (
      <div className="form-control relative flex-row items-center gap-4">
        {label && (
          <label className="label pt-0 pb-0" htmlFor={id}>
            <span className="label-text">
              {label}
              {required && "*"}:
            </span>
          </label>
        )}
        <div className="relative w-20">
          <input type="number" className={inputClasses} ref={ref} {...props} id={id} />
        </div>
        {error && (
          <label className="label absolute -bottom-5 p-0" htmlFor={id}>
            <span className="label-text-alt text-error">{error}</span>
          </label>
        )}
      </div>
    );
  },
);
